module.exports = {
  siteUrl: 'https://www.labelfolie.com',
  sitemapPath: '/sitemap.xml',
  title: 'Label Folie',
  description: "Booking - Production - Edition",
  author: '@oliviergenevest',
  locales: {fr:
    {
      path: 'fr',
      name: 'Français',
      default: true
    },
/*    en:
    {
      path: 'en',
      name: 'English'
    }*/
  },

};
